// Measures rendered text width in the app font via canvas `measureText`, with a fixed-average
// fallback when 2d canvas metrics are unavailable (e.g. jsdom under Vitest).

const FONT_BODY = '14px "Outfit Variable", sans-serif';
const FONT_HEADER = '500 12px "Outfit Variable", sans-serif';
const FALLBACK_CHAR_PX = 7;

let cachedCtx: CanvasRenderingContext2D | null | undefined;

function context(): CanvasRenderingContext2D | null {
  if (cachedCtx !== undefined) return cachedCtx;
  try {
    cachedCtx =
      typeof document === 'undefined'
        ? null
        : document.createElement('canvas').getContext('2d');
  } catch {
    cachedCtx = null;
  }
  return cachedCtx;
}

function measure(text: string, font: string): number {
  const ctx = context();
  if (ctx) {
    ctx.font = font;
    const width = ctx.measureText(text).width;
    if (width > 0) return width;
  }
  return text.length * FALLBACK_CHAR_PX;
}

/** Rendered width (px) of body-cell text in the grid's 14px font. */
export function measureBody(text: string): number {
  return measure(text, FONT_BODY);
}

/** Rendered width (px) of header text in the grid's 12px / 500-weight font. */
export function measureHeader(text: string): number {
  return measure(text, FONT_HEADER);
}
